export default {
    request: [],
    requestSales:[],
    requestPurchase:[]
  }
  